var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"sea-plus-icon",style:({ 'background-image': 'url(\'/ic-sea-plus-small.png\')' })})
}
var staticRenderFns = []

export { render, staticRenderFns }